import { render, staticRenderFns } from "./ModernInfinityDimensionsTab.vue?vue&type=template&id=39892b14&scoped=true&"
import script from "./ModernInfinityDimensionsTab.vue?vue&type=script&lang=js&"
export * from "./ModernInfinityDimensionsTab.vue?vue&type=script&lang=js&"
import style0 from "./ModernInfinityDimensionsTab.vue?vue&type=style&index=0&id=39892b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39892b14",
  null
  
)

export default component.exports